import { createRouter, createWebHashHistory } from 'vue-router'
// import solutionsRoute from './modules/solutionsRoute';



const routes = [
  { 
    path: '/', 
    component: ()=>import('@/layout'),
    redirect:'/index',
    children:[
      { path: '/index', component:()=>import('@/views/index') },
      { path: '/priceService', component:()=>import('@/views/priceService') },
      { path: '/solutions', component:()=>import('@/views/solutions') },
    ]
  },
  // ...solutionsRoute
  
]


const router = createRouter({
  history: createWebHashHistory(),
  routes, 
})

export default router